







































import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import {ISelectOption as iso} from '@/class/models/typed/wild';
import ClickOutside from 'vue-click-outside';
export type IOption = iso;

interface IGroupOptions {
  [groupValue: number]: iso[];
}
interface IOptionGroupSelect {
  [groupValue: number]: boolean;
}

export default Vue.extend({
  name: 'MultiSelectBox',
  props: {
    idkey: Number,
    initialValue: {
      type: String,
      default: '0',
    },
    options: Array as PropOptions<iso[]>,
    groupNames: Array as PropOptions<iso[]>,
    // pulldownStatus: Boolean,
    pulldownStatus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectedTexts: NOC.SELECT.NOSELECT.text,
      selectList: [] as number[],
      selectGroupList: {} as IOptionGroupSelect,
      selectorshow: false,
      closeList: [] as number[], // ツリーが閉じているグループIDのリスト
    };
  },
  directives: {
    ClickOutside,
  },
  watch: {
    selectList: {
      deep: true,
      handler(newList) {
        // すべて選択の自動チェック判定
        // グループ内の全員がチェックされていたらグループ自体をチェックする
        for (const groupValue of Object.keys(this.selectGroupList)) {
          if (this.GROUPS[Number(groupValue)].length > 0) { // グループ0人はチェック判定しない
            this.selectGroupList[Number(groupValue)] =
              this.GROUPS[Number(groupValue)].every((v) => newList.indexOf(v.value) !== -1);
          }
        }
        this.setSelectedText();
        const selectStr = this.exportSetData(this.selectList);
        this.$emit('change', selectStr || '0');
      },
    },
    initialValue: {
      immediate: true,
      handler(val) {
        this.selectList = this.importSetData(val);
      },
    },
  },
  computed: {
    NON_GROUP_AREA_ID: () => 0, // グループの枠自体を表示しない
    NON_GROUP_ID: () => -1, // 他のどのグループにも所属しないユーザー用の枠
    GROUPS(): IGroupOptions {
      const groups: IGroupOptions = {};
      if (!this.pulldownStatus) {
        if (!this.groupNames) {
          groups[this.NON_GROUP_AREA_ID] = this.options.filter((v) => v.value !== NOC.SELECT.NOSELECT.value);
        } else {
          // グループごとに振り分け
          for (const groupTextItem of this.groupNames) {
            groups[groupTextItem.value] = this.options.filter((v) => {
              return !v.groupValues ? false :
                v.value !== NOC.SELECT.NOSELECT.value && v.groupValues.split(',').some((v2) => Number(v2) === groupTextItem.value);
            });
          }
          // グループなしのユーザーがいればグループ無し枠を作成
          const nonGroup = this.options.filter((v) => !v.groupValues && v.value !== NOC.SELECT.NOSELECT.value);
          if (nonGroup.length) {
            groups[this.NON_GROUP_ID] = nonGroup;
          }
        }
      } else {
       if (!this.groupNames) {
         groups[this.NON_GROUP_AREA_ID] = this.options.filter((v) => v.value !== NOC.SELECT.NOSELECT.value);
       } else {
         // 部署ごとに振り分け
         for (const groupTextItem of this.groupNames) {
           groups[groupTextItem.value] = this.options.filter((v) => {
             return !v.departmentValues ? false :
               v.value !== NOC.SELECT.NOSELECT.value && v.departmentValues === groupTextItem.value;
           });
         }
         // 部署なしのユーザーがいれば部署無し枠を作成
         const nonGroup = this.options.filter((v) => !v.departmentValues && v.value !== NOC.SELECT.NOSELECT.value);
         if (nonGroup.length) {
           groups[this.NON_GROUP_ID] = nonGroup;
         }
       }
      }
      return groups;
    },
  },
  mounted() {
    for (const groupValue of Object.keys(this.GROUPS)) { // indexがgroupValueのオブジェクトを初期化
      this.selectGroupList[Number(groupValue)] = false;
    }
    this.setSelectedText();
    this.selectList = this.importSetData(this.initialValue);
  },
  methods: {
    onClickItem(value: number) {
      const clickedIndex = this.selectList.findIndex((v) => v === value);
      if (clickedIndex > -1) { // 削除
        this.selectList.splice(clickedIndex, 1);
      } else { // 追加
        this.selectList.push(value);
      }
    },
    onClickAll(groupValue: number) {
      this.selectGroupList[groupValue] = !this.selectGroupList[groupValue];
      if (this.GROUPS[groupValue].length < 1) {
        // 0人のグループ選択時はselectListそのままでwatch呼び出し
        this.selectList = Array.from(new Set(this.selectList));
        return;
      }
      if (this.selectGroupList[groupValue]) { // すべて選択
        const selectList = this.selectList.concat(this.GROUPS[groupValue].map((v) => v.value));
        this.selectList = Array.from(new Set(selectList));
      } else { // すべて解除
        this.selectList = this.selectList.filter((v) => !this.GROUPS[groupValue].some((v2) => v2.value === v));
      }
    },
    onClickTreeArrow(groupValue: number) {
      const clickedIndex = this.closeList.findIndex((v) => v === groupValue);
      if (clickedIndex > -1) { // 削除
        this.closeList.splice(clickedIndex, 1);
      } else { // 追加
        this.closeList.push(groupValue);
      }
    },
    closeSelect() {
      this.selectorshow = false;
      this.$emit('openclose', this.selectorshow);
    },
    onMouseMove(event: any) { // ちらつき防止
      if (event.buttons < 1 && this.selectorshow) {
        event.stopImmediatePropagation();
      }
    },
    getGroupName(groupValue: number) {
      if (!this.groupNames) {
        return '';
      }
      const groupTextItem = this.groupNames.find((v) => Number(v.value) === Number(groupValue));
      return groupTextItem ? groupTextItem.text : 'グループなし';
    },
    importSetData(initialValue: string): number[] {
      // g1,1,2 ならグループ1全員とユーザー1,2
      const initialList = initialValue.split(',');
      let selectList: number[] = [];
      for (const value of initialList) {
        if (value === 'all') { // 全員
          for (const groupValue of Object.keys(this.GROUPS)) {
            selectList = selectList.concat(this.GROUPS[Number(groupValue)].map((v) => v.value));
          }
        } else if (value.includes('g')) {// else if (value.indexOf('g') !== -1) { // グループ
          const groupID = value.substring(1, value.length);
          if (this.GROUPS[Number(groupID)]) {
            selectList = selectList.concat(this.GROUPS[Number(groupID)].map((v) => v.value));
          }
        } else if (value.includes('d')) {// else if (value.indexOf('d') !== -1) { // 部署
          const departmentID = value.substring(1, value.length);
          if (this.GROUPS[Number(departmentID)]) {
            selectList = selectList.concat(this.GROUPS[Number(departmentID)].map((v) => v.value));
          }
        } else {
          if (Number(value) !== NOC.SELECT.NOSELECT.value) {
            selectList.push(Number(value));
          }
        }
      }
      return selectList;
    },
    exportSetData(selectList: number[]): string {
      let textArray: string[] = [];
      let mySelectList: number[] = [];
      mySelectList = mySelectList.concat(selectList);
      const isGroupMember = (groupID: number, optionValue: number) =>
        this.GROUPS[groupID].some((v2) => optionValue === v2.value);

      for (const groupValue of Object.keys(this.selectGroupList)) {
        const groupValueNum = Number(groupValue);
        if (this.selectGroupList[groupValueNum] &&
          groupValueNum !== this.NON_GROUP_AREA_ID && groupValueNum !== this.NON_GROUP_ID) {
          // すべて選択なら`g${グループID}`
          // ※グループなしの場合は個別のIDを保存
          if (!this.pulldownStatus) {
            textArray.push(`g${groupValue}`);
          } else {
            textArray.push(`d${groupValue}`);
          }
          mySelectList = mySelectList.filter((v) => !isGroupMember(groupValueNum, v));
        }
      }
      // 残りは個別にユーザーID/グループIDを保存
      textArray = textArray.concat(mySelectList.map((v) => String(v)));
      // 空白と重複を排除して連結
      textArray = Array.from(new Set(textArray.filter((v) => v !== '')));
      return textArray.join(',');
    },
    setSelectedText() {
      // 全員なら"すべてのユーザー"
      // グループ全員ならグループ名、一部選択ならグループ"の何名"
      let textArray: string[] = [];
      let isAll = true;
      for (const groupValue of Object.keys(this.selectGroupList)) {
        const groupValueNum = Number(groupValue);
        if (this.selectGroupList[groupValueNum]) { // すべて選択
          textArray.push(this.getGroupName(groupValueNum));
        } else {
          isAll = false;
          // グループ内で何人選択されたかカウント
          const optionLength = this.GROUPS[groupValueNum].reduce((sum: number, current: iso) => {
            return sum + (this.selectList.indexOf(current.value) !== -1 ? 1 : 0);
          }, 0);
          if (optionLength) {
            if (groupValueNum === this.NON_GROUP_AREA_ID) {
              // グループの枠を表示していないときはユーザー名またはグループ名を羅列
              textArray = this.selectList.map((v) => {
                const found = this.GROUPS[groupValueNum].find((v2) => v2.value === v);
                return found ? found.text : '';
              });
            } else {
              textArray.push(this.getGroupName(groupValueNum) + `の${optionLength}名`);
            }
          }
        }
      }
      this.selectedTexts = isAll ? 'すべて'
        : textArray.length ? textArray.join(',') : NOC.SELECT.NOSELECT.text;
    },
  },
});
